import Axios from "../api/axios";
import config from "../../config";

const getAdviceNote = () => {
  return Axios.get(`${config.BASE_URL}advice`);
};

export default getAdviceNote;
